
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18.109","height":"13.049"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(.608 .599)","fill":"none","stroke":"#9ea9c8","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('circle',{attrs:{"cx":"3.074","cy":"3.074","r":"3.074","transform":"rotate(-77.025 7.221 -1.347)"}}),_c('path',{attrs:{"d":"M4.189 11.841s.765-2.988 6.41-2.988 6.305 2.988 6.305 2.988"}}),_c('circle',{attrs:{"cx":"1.612","cy":"1.612","transform":"rotate(-77.025 5.082 2.412)","r":"1.612"}}),_c('path',{attrs:{"d":"M0 10.089s.436-1.7 3.655-1.7a4.7 4.7 0 013 .844"}})])])
          )
        }
      }
    